import HI from "@/lib/hi.json";

const KEY = "ks_lang";
let current = typeof localStorage !== "undefined" && localStorage.getItem(KEY) === "hi" ? "hi" : "en";

export const getLang = () => current;

export function setLangGlobal(lang) {
  current = lang === "hi" ? "hi" : "en";
  localStorage.setItem(KEY, current);
  document.documentElement.lang = current;
}

// Lookup by English source text; falls back to English when a translation is missing.
export function t(text) {
  if (current !== "hi" || typeof text !== "string") return text;
  return HI[text] || text;
}

export const tf = (text, vars) => Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), t(text));
